import * as React from 'react';
import {graphql } from 'gatsby';
import {BuilderComponent, BuilderContent } from '@builder.io/react';

interface Props {
  data: {
    allBuilderModels: {
      page: Array<{
        content: any
      }>
    }
  }
}

const PageModelComponent: React.FC<Props> = ({data}) => {
  const models = data?.allBuilderModels;
  const page = models.page[0]?.content;

  return <BuilderComponent
    content={page}
    model="page" />
}

export default PageModelComponent;      

export const query = graphql`
  query($path: String!) {
    allBuilderModels {
      page(
        target: { urlPath: $path }
        limit: 1
        options: { cachebust: true }
      ) {
        content
      }
    }
  }
`